import { useMemo } from 'react';
import { get } from 'lodash';
import { useCategoryBrandFieldsApi } from '../../../common/hooks';

export interface DescriptionAndOverview {
  description: string | undefined;
  overview: string | undefined;
  metaDescription: string | undefined;
  metaTitle: string | undefined;
}

const useDetermineDescriptionAndOverview = (
  activeTopBrand: any,
  category: any
): DescriptionAndOverview => {
  const { response: categoryBrandFieldsResponse } = useCategoryBrandFieldsApi(
    category?.id,
    activeTopBrand?.id
  );
  const categoryBrandFields = category?.id
    ? get(categoryBrandFieldsResponse, 'content[0]', {})
    : {};

  return useMemo(() => {
    let desc, overview, metaDesc, metaTitle;
    if (activeTopBrand) {
      // dont fallback description, brand desc is displayed in a different place
      desc = categoryBrandFields.description;
      overview =
        categoryBrandFields.overview || get(activeTopBrand, 'brandOverview');
      metaDesc =
        categoryBrandFields.metaDescription ||
        get(activeTopBrand, 'metaDescription');
      metaTitle =
        categoryBrandFields.metaTitle || get(activeTopBrand, 'metaTitle');
    } else {
      desc = category?.description;
      overview = category?.categoryOverview;
      metaDesc = category?.metaDescription;
      metaTitle = category?.metaTitle;
    }

    return {
      description: desc,
      overview: overview,
      metaDescription: metaDesc,
      metaTitle: metaTitle
    };
  }, [activeTopBrand, category, categoryBrandFields]);
};

export default useDetermineDescriptionAndOverview;
